var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"chart-container",style:({ height: _vm.chartHeight + 'px' })},[_c('canvas',{ref:"canvasRef"})])
}
var staticRenderFns = []

export { render, staticRenderFns }